import { TextColumns } from '@phosphor-icons/react';

export default TextColumns;
